/* eslint-disable no-unused-vars */
import moment from 'moment';
import { store } from 'redux/store';
import _, { isEmpty } from 'lodash';
import { extractVisibleTextFromHTMLString } from '@utilities/helper.util';

const assignedAndSyncedWorkOrderManipulationJson = async ({
  workOrderCache,
  syncWorkOrderCache,
  initialLogin
}) => {
  const { tasks } = store.getState();

  const allWOTasksMap =
    tasks?.tasksList?.length > 0 && !initialLogin
      ? tasks.tasksList.reduce((acc, task) => {
          acc[task.workorderId] = true;
          return acc;
        }, {})
      : {};

  // await cacheWorkOrderPhotosAndDocuments({ workOrderCache });

  // const tasksDescription = `
  //   <p>test paragraph hanan ahmad</p>
  //   <p><test>test bold</test italicstrong> <em></em>
  //   <span style="text-decoration:underline;">test underline</span></p>
  //   <ol>
  //     <li>ads fas</li>
  //     <li>id fa</li>
  //     <li>k</li>
  //     <li>asd</li>
  //   </ol>
  // `;

  const workOrdersAll = [
    ...(syncWorkOrderCache?.map((wo) => ({
      ...wo,
      status: 'Synced',
      statusId: wo.status,
      type: wo.entityType === 'WorkRequest' ? 'Work Request' : 'Work Order',
      id: wo.workOrderNumber
    })) || []),

    ...(workOrderCache?.map((wo) => ({
      ...wo,
      status: 'To do',
      statusId: wo.status,
      type: 'Work Order',
      id: wo.workOrderNumber,
      description: extractVisibleTextFromHTMLString({
        htmlString: wo?.description
      }),
      tasksDescriptionWIthHTMLTags: wo?.description
    })) || [])
  ];

  let newSyncedTask = [];
  if (!_.isEmpty(allWOTasksMap)) {
    newSyncedTask = workOrdersAll.map((task) => {
      if (!allWOTasksMap[task.workorderId]) {
        return {
          syncDateCustom: moment().format('YYYY-MM-DD'),
          ...task
        };
      } else return task;
    });
  } else newSyncedTask = workOrdersAll;

  const recurringTemplatesMap = {};

  const tasksList = (newSyncedTask || []).map((task) => {
    const { rtId, rtName, rtNumber, workOrderNumber } = task;
    if (rtId && !recurringTemplatesMap[rtId]) {
      const allWorkOrder = (newSyncedTask || []).filter((x) => x.rtId === rtId) || [];
      const allDoneTasks = allWorkOrder.filter((task) => task?.status === 'Synced') || [];
      const allotDoneTasks = allWorkOrder.filter((task) => task?.status !== 'Synced') || [];

      const today = moment().format('YYYY-MM-DD');
      const isOverDue = allotDoneTasks.find((task) =>
        task.dueDate ? moment(task.dueDate).isBefore(today) : false
      );

      recurringTemplatesMap[rtId] = {
        rtId,
        title: rtName,
        id: rtNumber,
        allWorkOrder: _.size(allWorkOrder),
        allDoneTasks: _.size(allDoneTasks),
        allotDoneTasks: _.size(allDoneTasks),
        isOverDue: isOverDue
      };
    }

    return {
      ...task,
      type: task?.entityType === 'WorkRequest' ? 'Work Request' : 'Work Order',
      id: workOrderNumber || ''
    };
  });

  let tasksAll = [
    ...tasks.tasksList.filter((t) => t.status === 'Pending sync' || t.status === 'In progress')
  ];

  tasksList.map((task) => {
    const found = tasksAll.findIndex((t) => t.workorderId === task.workorderId) + 1;
    if (found) {
      if (!['In progress', 'Pending sync'].includes(tasksAll[found - 1].status)) {
        tasksAll[found - 1] = { ...task };
      }
    } else {
      tasksAll.push({ ...task });
    }
  });

  let map = {};

  for (let i = 0; i < tasksAll.length; i++) {
    const obj = tasksAll[i];

    const id = obj.workorderId || obj.woId;
    map[id] = obj;
  }

  return {
    workOrdersMap: { ...map },
    tasksList: [...tasksAll],
    recurringTemplatesMap: recurringTemplatesMap
  };
};

const cacheWorkOrderPhotosAndDocuments = async ({
  workOrderCache,
  newSettings = {},
  cmlPhotos = [],
  cmlDocuments = [],
  isCML = false,
  throwError = false
}) => {
  const { settings } = store.getState();
  const settingsForImagesAndDocumentsCaching = isEmpty(settings?.settings)
    ? newSettings
    : settings?.settings;

  try {
    // caches.delete('images');

    if (isCML) {
      if (cmlPhotos?.length > 0) {
        if (navigator.onLine) {
          console.log('CML Images Caching start');
          const cache = await caches.open('images');
          let images = [];
          cmlPhotos?.map((p) => images.push(p?.url));
          await Promise.all(
            images.map(async (url) => {
              const res = await fetch(url, { mode: 'cors' });
              await cache.put(url, res.clone());
            })
          );
        } else if (throwError) {
          throw new Error('Device is offline, cannot cache CML images');
        }
      }
    } else {
      if (
        navigator.onLine &&
        settingsForImagesAndDocumentsCaching?.autoConnectWOPhoto !== 'never'
      ) {
        let connection = 'wifi';
        if ('connection' in navigator) {
          connection = navigator.connection.type || 'wifi';
        }
        if (
          (settingsForImagesAndDocumentsCaching?.autoConnectWOPhoto === 'wifi' &&
            connection !== 'cellular') ||
          settingsForImagesAndDocumentsCaching?.autoConnectWOPhoto === 'any'
        ) {
          console.log('Work Order Images Caching start');

          let images = [];
          workOrderCache?.map((data) => data?.photos?.map((p) => images.push(p?.url)));
          const cache = await caches.open('images');

          await Promise.all(
            images.map(async (url) => {
              const res = await fetch(url, { mode: 'cors' });
              await cache.put(url, res.clone());
            })
          );
        }
      }
    }
  } catch (err) {
    console.log('Work Order Images Caching failed');
    if (throwError) throw new Error('Work Order Images Caching failed');
  }

  try {
    caches.delete('documents');

    if (isCML) {
      if (cmlDocuments?.length > 0) {
        if (navigator.onLine) {
          let documents = [];
          console.log('CML documents download');
          cmlDocuments?.map((p) => documents.push(p?.url));
          await Promise.all(documents.map((link) => fetch(link)));
        } else if (throwError) {
          throw new Error('Device is offline, cannot cache CML images');
        }
      }
    } else {
      if (
        navigator.onLine &&
        settingsForImagesAndDocumentsCaching?.autoConnectWODocument !== 'never'
      ) {
        let connection = 'wifi';

        if ('connection' in navigator) {
          connection = navigator.connection.type || 'wifi';
        }

        if (
          (settingsForImagesAndDocumentsCaching?.autoConnectWODocument === 'wifi' &&
            connection !== 'cellular') ||
          settingsForImagesAndDocumentsCaching?.autoConnectWODocument === 'any'
        ) {
          console.log('Work Order Documents Caching start');

          let documents = [];

          workOrderCache?.map((data) => data?.documents?.map((p) => documents.push(p?.url)));
          await Promise.all(documents.map((link) => fetch(link)));
        }
      }
    }
  } catch (err) {
    console.log('Work Order Documents Caching failed');
    if (throwError) throw new Error('Work Order Documents Caching failed');
  }
};
export { assignedAndSyncedWorkOrderManipulationJson, cacheWorkOrderPhotosAndDocuments };
